import { render, staticRenderFns } from "./ForgottenPassword.vue?vue&type=template&id=52b32edc&scoped=true&"
import script from "./ForgottenPassword.vue?vue&type=script&lang=js&"
export * from "./ForgottenPassword.vue?vue&type=script&lang=js&"
import style0 from "./ForgottenPassword.vue?vue&type=style&index=0&id=52b32edc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b32edc",
  null
  
)

export default component.exports